import { RefObject } from "react";

export const handleScroll = (ref: RefObject<HTMLElement>) => {
  window.scrollTo({
    top: ref.current?.offsetTop,
    behavior: "smooth",
  });
};
